import { html } from 'lit';
import { Heart } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-heart')
export class PdsIconHeart extends PdsIcon {
  @state()
  icon = Heart;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
